import { apiClient } from './client';
import type { components } from './schema.gen';

/**
 * AttributeDefinition view from /v1/attribute-definitions. The
 * `payloadSchema` field is intentionally typed as `unknown` upstream —
 * it carries an arbitrary JSON Schema (draft 2020-12) that the UI
 * inspects at runtime to generate the manual-declaration form.
 */
export type AttributeDef = components['schemas']['AttributeDefinitionView'];

export async function listAttributeDefinitions(): Promise<AttributeDef[]> {
  const { data, error } = await apiClient.GET('/v1/attribute-definitions');
  if (error || !data) return [];
  return (data.items ?? []) as AttributeDef[];
}
